<template>
  <div class="mx-auto">
    <div class="d-flex cards">
      <div>
        <v-card style="box-shadow: 2px 2px 2px solid red">
          <v-card-title>Monthly Cost <v-icon large class="ml-8"  color="rgb(54, 129, 167)">mdi-calendar-month</v-icon>
             </v-card-title>
          
          <v-card-text>
            <div style="color:rgb(54, 129, 167); font-size:16px" >
              <span class="rupee">&#8377;</span>
              <strong>{{ $toFixed(monthlyCost) }}</strong>
                </div>

          </v-card-text>
        </v-card>
      </div>

      <div>
        <v-card>
          <v-card-title>Wallet Balance  <v-icon large class="ml-8"  color="rgb(54, 129, 167)">mdi-wallet</v-icon>
             </v-card-title>
          <v-card-text>
            <div style="color:rgb(54, 129, 167)">
              <span class="rupee">&#8377;</span>
              <strong>{{ $toFixed(walletBalance, 2) }}</strong>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <div>
        <v-card>
          <v-card-title>Base Pack {{ basePackExpired ? 'Expired' : 'Expires' }} On  <v-icon large class="ml-4"  color="rgb(54, 129, 167)">mdi-clock-alert</v-icon>
             </v-card-title>
          <v-card-text>
            <div style="color:rgb(54, 129, 167)">
              <strong>{{ basePack ? basePack.end_DATE : 'No Base Pack' }}</strong>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-card-text class="text-center">Keep your Account Top Up to enjoy Uninterrupted Service</v-card-text>
    <v-card-actions>
      <div class="mx-auto">
        <Button
        @click="goTo('/topup')"
          color="primary"
          cssClass="mb-8 topup"
          label="Top Up"
          rounded
        />
      </div>
    </v-card-actions>
  </div>
</template>
<script>
import Button from "@/components/Elements/Button.vue";
import { mapState, mapGetters, } from 'vuex';

export default {
  components: {
    Button
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('auth', ['walletBalance']),
    ...mapGetters('auth', ['monthlyCost', 'basePack', 'isDP']),
    basePackExpired() {
      return this.basePack && this.basePack.expired === true;
    }
  },
  methods:{
    goTo(path, params) {
      this.$router.push({
        path,
        params
      });
    }
  }
};
</script>
<style scoped>
.cards {
  padding-top: 50px;
  padding-bottom: 40px;
  justify-content: space-evenly;
  cursor: pointer;
}
.cards > div > div {
  height: 110px;
  min-width: 250px;
  border-radius: 10px !important;
}
.rupee {
  margin-left: 5px;
  margin-right: 5px;
}
.topup {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}
.theme--light.v-card{
  box-shadow: 0px 0px 25px rgb(225, 237, 255) !important;
}
.theme--light.v-card:hover{
  box-shadow: 0px 0px 25px rgb(54, 129, 167) !important;
  transition: 0.5s;
  	transform: translateY(-5px);
}
</style>